import { render, staticRenderFns } from "./reservationRecord.vue?vue&type=template&id=570ce99c&scoped=true&"
import script from "./reservationRecord.vue?vue&type=script&lang=js&"
export * from "./reservationRecord.vue?vue&type=script&lang=js&"
import style0 from "./reservationRecord.vue?vue&type=style&index=0&id=570ce99c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570ce99c",
  null
  
)

export default component.exports